import { render, staticRenderFns } from "./16zhihuidangjian.vue?vue&type=template&id=38d6af5e&scoped=true&"
import script from "./16zhihuidangjian.vue?vue&type=script&lang=js&"
export * from "./16zhihuidangjian.vue?vue&type=script&lang=js&"
import style0 from "./16zhihuidangjian.vue?vue&type=style&index=0&id=38d6af5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d6af5e",
  null
  
)

export default component.exports